'use es6';

export const getMenuNodesById = state => state.nodesById;
export const getMenuNode = (state, props) => state.nodesById[props.id];